export function formatarMoedaComRS(valor) {
    return valor !== undefined ? valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : 0.00.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
}

export function formatarMoeda(valor) {
    return valor !== undefined ? valor.toLocaleString('pt-br', { minimumFractionDigits: 2 }) : 0.00.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
}

export function removeArray(arr, value) {
    return arr.filter((obj) => {
        return obj !== value
    })
}

export function extractFromAddress(components, type, shortName = false) {
    for (var i = 0; i < components.length; i++) {
        for (var j = 0; j < components[i].types.length; j++) {
            if (components[i].types[j] === type) {
                return shortName ? components[i].short_name : components[i].long_name
            }
        }
    }
    return ''
}

export function getReais(valor) {
  let valores = (valor + "").split(".")
  return valores[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function getCentavos(valor) {
  let valores = (valor + "").split(".")
  
  if(!valores[1]) { return "00" }
  if(valores[1].length == 1) { return valores[1] + "0" }
  
  return valores[1]
}

export function getNumeroSemFormatacao(numero) {
  if(!numero) { return undefined }
  
  let numeroSemFormatacao = numero
  if(numero.endsWith(",00")) {
    numeroSemFormatacao = numeroSemFormatacao.replace(",00", "");
  }

  numeroSemFormatacao = numeroSemFormatacao.replace(/\./g, "")
  numeroSemFormatacao = numeroSemFormatacao.replace(",", ".")

  return numeroSemFormatacao;
}